import { type FC } from 'react';
import type { NodeProps } from 'reactflow';
import type { NodeData } from '@/types/node.types';
import BaseNode from './BaseNode';

const OBJECTIVE_COLOR = '#3B82F6';

export const ObjectiveNode: FC<NodeProps<NodeData>> = ({ id, data, selected }) => {
  return <BaseNode id={id} data={data} color={OBJECTIVE_COLOR} icon={'\u25CE'} selected={selected} />;
};

export default ObjectiveNode;
